import { DetailCard } from '@/common/components/detail-card/DetailCard.tsx';
import { PropertyList } from '@/common/components/property-list/PropertyList.tsx';
import { Trans } from '@lingui/react/macro';
import { LastEventsResponse } from '@/features/dispensers/services/schemas.ts';
import { findEventOfType } from '@/features/dispensers/utils/lastEvent.ts';
import { EventTypeEnum } from '@/features/events/types/EventType.ts';
import { LastEventDisplay } from '@/features/dispensers/components/dispenser-detail/subcomponents/last-event-display/LastEventDisplay.tsx';

export interface LastEventsCardProps {
  lastEvents: LastEventsResponse;
}

export const LastEventsCard = ({ lastEvents }: LastEventsCardProps) => {
  const lastDispensing = findEventOfType(lastEvents, EventTypeEnum.DISPENSING);
  const lastError = findEventOfType(lastEvents, EventTypeEnum.ERROR);
  const lastRefill = findEventOfType(lastEvents, EventTypeEnum.REFILL);
  const lastPurge = findEventOfType(lastEvents, EventTypeEnum.PURGE);

  return (
    <DetailCard title={<Trans>Last Events</Trans>}>
      <PropertyList>
        <PropertyList.Item
          label={<Trans>Last Dispensing</Trans>}
          value={lastDispensing ? <LastEventDisplay event={lastDispensing} /> : null}
        />
        <PropertyList.Item
          label={<Trans>Last Error</Trans>}
          value={lastError ? <LastEventDisplay event={lastError} /> : null}
        />
        <PropertyList.Item
          label={<Trans>Last Refill</Trans>}
          value={lastRefill ? <LastEventDisplay event={lastRefill} /> : null}
        />
        <PropertyList.Item
          label={<Trans>Last Purge</Trans>}
          value={lastPurge ? <LastEventDisplay event={lastPurge} /> : null}
        />
      </PropertyList>
    </DetailCard>
  );
};
